export default function ProductsToolbarIcon() {
  return (
    <svg width={22} height={22}>
      <g fill="none" fillRule="evenodd">
        <path fill="#D3E6F8" d="M21.569 16.314L11 21.627.431 16.314V5.686L11 .373l10.569 5.313z" />
        <path fill="#FFF" d="M.431 5.704l10.233 5.132 10.783-5.199L10.988.373.431 5.686z" />
        <path fill="#A4CFF2" d="M21.569 16.314V5.88l-10.497 5.131v10.563z" />
        <path fill="#FD919E" d="M2.732 9.172v6.01l5.752 2.886v-6.034z" />
        <g fill="#4C4372">
          <path
            fillRule="nonzero"
            d="M11 22a.482.482 0 0 1-.217-.05L.215 16.636A.367.367 0 0 1 0 16.314V5.686c0-.132.082-.255.215-.322L10.783.05a.491.491 0 0 1 .434 0l10.568 5.314c.133.067.215.19.215.322v10.628a.367.367 0 0 1-.215.322L11.217 21.95A.482.482 0 0 1 11 22zM.863 16.1L11 21.195l10.137-5.097V5.901L11 .804.863 5.901v10.198z"
          />
          <path d="M11 11.373a.482.482 0 0 1-.217-.05L.39 6.105c-.206-.103-.276-.332-.156-.51.12-.178.383-.238.59-.135L11 10.569l10.11-5.074c.206-.104.47-.043.59.135s.049.406-.157.51l-10.326 5.183a.487.487 0 0 1-.217.05z" />
          <path d="M11 21.751c-.238 0-.431-.167-.431-.372V11c0-.206.193-.373.431-.373s.431.167.431.373v10.379c0 .205-.193.372-.431.372zm5.396-13.124a.485.485 0 0 1-.214-.05L5.567 3.325c-.207-.102-.279-.33-.16-.509.118-.179.382-.24.588-.138L16.611 7.93c.207.102.279.33.16.509a.447.447 0 0 1-.375.188z" />
          <path
            fillRule="nonzero"
            d="M8.484 18.44a.482.482 0 0 1-.217-.05l-5.752-2.886a.367.367 0 0 1-.214-.322v-6.01c0-.134.082-.257.215-.323a.49.49 0 0 1 .431 0L8.7 11.71c.134.066.216.19.216.323v6.034a.367.367 0 0 1-.216.323.482.482 0 0 1-.215.05zm-5.32-3.473l4.888 2.453v-5.17L3.163 9.815v5.151z"
          />
        </g>
      </g>
    </svg>
  );
}
